var map = {
	"./Contact.vue": [
		1373,
		373
	],
	"./Fotos.vue": [
		6229,
		229
	],
	"./HomeView.vue": [
		3631
	],
	"./Informatie.vue": [
		7401
	],
	"./Parcours.vue": [
		5082
	],
	"./Portfolio.vue": [
		1808,
		808
	],
	"./Privacy.vue": [
		3103
	],
	"./SinglePortfolio.vue": [
		87,
		87
	],
	"./Sponsors.vue": [
		5510,
		510
	],
	"./Zwembaden.vue": [
		5469,
		469
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 2513;
module.exports = webpackAsyncContext;